const isString = (value) => typeof value === 'string' || value instanceof String
const isObject = obj => obj !== null && typeof obj === 'object' && !Array.isArray(obj)

// getSTP() == Scroll from Top Position
function getSTP() {
	var d = document.documentElement,
		st = (window.pageYOffset || d.scrollTop) - (d.clientTop || 0);
	return parseInt(st)
}

const requestAnimationFrame = (f) => {
	return (
		window.requestAnimationFrame(f) ||
		window.mozRequestAnimationFrame(f) ||
		window.webkitRequestAnimationFrame(f) ||
		window.msRequestAnimationFrame(f) ||
		function(f) {
			return setTimeout(f, 1000 / 60)
		}
	)
} 

const cancelAnimationFrame = (f) => {
	return (
		window.cancelAnimationFrame(f) || 
		// window.webkitCancelAnimationFrame(f) || 
		// window.webkitCancelRequestAnimationFrame(f) || 
		// window.mozCancelAnimationFrame(f) || 
		function(f) {
			clearTimeout(f)
		}
	)
}

const mouseWheel = /Firefox/i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel'

const addEventListener = (element, type, callback) => {
	if (element.addEventListener) {
		element.addEventListener(type, callback, false);
	} else if (element.attachEvent) {
		element.attachEvent('on' + type, callback);
	}
};

function preventEventDefaults(e) {
	if (!e) {
		e = window.event;
	}
	if (e.preventDefault) {
		e.preventDefault();
	}
	e.returnValue = false;
}

const checkCursor = (e) => {
	if (e.type == 'mousedown') {
		var e = e;
	} else if (e.touches) {
		var e = e.touches[0];
	}
	return { x: e.clientX, y: e.clientY }
};

const elementInWindow = element => {
	return getSTP() + window.innerHeight > parseInt(element.offset().top) && getSTP() + window.innerHeight < parseInt(element.offset().top) + window.innerHeight + parseInt(element.offsetHeight)
}

// document.getElementById('single_content').offset().top
Element.prototype.offset = function() {
	var _t, top, left, height, width, obj;
	_t = this.getBoundingClientRect()
	top = getSTP() + _t.top
	left = _t.left
	height = _t.height
	width = _t.width
	obj = {
		'top': parseInt(top),
		'left': parseInt(left),
		'width': parseInt(width),
		'height': parseInt(height)
	}
	return obj
}

// document.getElementById('single_content').offset().top
Element.prototype.offset = function() {
	var _t, top, left, height, width, obj;
	_t = this.getBoundingClientRect()
	top = getSTP() + _t.top
	left = _t.left
	height = _t.height
	width = _t.width
	obj = {
		'top': parseInt(top),
		'left': parseInt(left),
		'width': parseInt(width),
		'height': parseInt(height)
	}
	return obj
}

Element.prototype.setProperty = function(property, value) {
	this.style.setProperty('-webkit-' + property, value);
	this.style.setProperty('-moz-' + property, value);
	this.style.setProperty('-ms-' + property, value);
	this.style.setProperty('-o-' + property, value);
	this.style.setProperty(property, value);
	return this;
}

Element.prototype.removeProperty = function(property) {
	this.style.removeProperty('-webkit-' + property);
	this.style.removeProperty('-moz-' + property);
	this.style.removeProperty('-ms-' + property);
	this.style.removeProperty('-o-' + property);
	this.style.removeProperty(property);
	return this;
}

// element.hasAttr('class', 'active')
// will not add indexed value cuz its already indexed, make array
Element.prototype.hasAttr = function(attribute, thisValue) {
	var c = this.getAttribute(attribute);
	if (c) {
		if (!thisValue && thisValue !== false) {
			return true
		}  else if (typeof thisValue === 'boolean') {
			return thisValue
		} else {
			thisValue = String(thisValue);
		
			var arr = c.split(' '),
				arr_l = arr.length;
			thisValue = thisValue.replace(/\s+/g, '');

			for (var i = 0; i < arr_l; i++) {
				if (thisValue, arr[i] === thisValue) {
					return true;
				} else if (i == arr_l - 1) {
					return false;
				}
			}
		}
	} else {
		return false;
	}
}

export {
	getSTP,

	addEventListener,
    mouseWheel,
    checkCursor,
    preventEventDefaults,
    requestAnimationFrame,
    cancelAnimationFrame,
    elementInWindow,
	isString,
	isObject
}